import React, { useEffect, useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import ReactDOM from 'react-dom';
import logo from '../assets/images/logo.png';
import AuthService from '../services/AuthService';
import './Sidebar.css';

const NAV = [
  { to: '/partner/dashboard', icon: 'bi-grid-fill',      label: 'Dashboard' },
  { to: '/partner/bookings',  icon: 'bi-calendar-check', label: 'Bookings'  },
  { to: '/partner/services',  icon: 'bi-grid',            label: 'Services'  },
  { to: '/partner/timings',   icon: 'bi-clock',           label: 'Timings'   },
  { to: '/partner/profile',   icon: 'bi-person-fill',     label: 'Profile'   },
];

const PartnerSidebar = () => {
    const navigate = useNavigate();
    const [showLogout, setShowLogout] = useState(false);

    useEffect(() => {
        const button   = document.getElementById('kt_app_sidebar_mobile_toggle');
        const menuLinks = document.querySelectorAll('.menu-link');

        const toggleSidebar = () => {
            const sidebar = document.getElementById('kt_app_sidebar');
            if (sidebar) sidebar.style.display = sidebar.style.display === 'block' ? 'none' : 'block';
        };
        const hideSidebar = () => {
            const sidebar = document.getElementById('kt_app_sidebar');
            if (sidebar && window.innerWidth <= 990) sidebar.style.display = 'none';
        };

        if (button) button.addEventListener('click', toggleSidebar);
        menuLinks.forEach(l => l.addEventListener('click', hideSidebar));
        return () => {
            if (button) button.removeEventListener('click', toggleSidebar);
            menuLinks.forEach(l => l.removeEventListener('click', hideSidebar));
        };
    }, []);

    const handleLogout = () => {
        AuthService.partnerLogout?.() || (() => {
            localStorage.removeItem('partner');
            navigate('/partner/login');
        })();
        setShowLogout(false);
    };

    return (
        <>
        <div
            id="kt_app_sidebar"
            className="app-sidebar partner-sidebar flex-column"
            data-kt-drawer="true"
            data-kt-drawer-name="app-sidebar"
            data-kt-drawer-activate="{default: true, lg: false}"
            data-kt-drawer-overlay="true"
            data-kt-drawer-width="280px"
            data-kt-drawer-direction="start"
            data-kt-drawer-toggle="#kt_app_sidebar_mobile_toggle"
        >
            {/* Logo */}
            <div className="sidebar-header p-2 pb-1 d-flex justify-content-start align-items-center position-relative border-bottom">
                <img src={logo} alt="LMTKOM" className="logo-image mx-5 w-80px" />
            </div>

            <div className="sidebar-menu flex-grow-1 overflow-auto bg-white">
                <div className="menu-section">
                    {NAV.map(({ to, icon, label }) => (
                        <div className="menu-item" key={to}>
                            <NavLink to={to} className="menu-link">
                                <span className="menu-icon"><i className={`bi ${icon}`}></i></span>
                                <span className="menu-title">{label}</span>
                            </NavLink>
                        </div>
                    ))}
                </div>

                {/* Bottom: logout */}
                <div className="sidebar-footer">
                    <button
                        className="menu-link w-100 border-0 bg-transparent text-start"
                        onClick={() => setShowLogout(true)}
                    >
                        <span className="menu-icon"><i className="bi bi-box-arrow-right"></i></span>
                        <span className="menu-title text-danger">Logout</span>
                    </button>
                    <p className="copyright-text mt-3">© Copyright All Rights Reserved {new Date().getFullYear()}</p>
                </div>
            </div>
        </div>

        {/* Logout confirmation portal */}
        {showLogout && ReactDOM.createPortal(
            <>
                <div
                    onClick={() => setShowLogout(false)}
                    style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.55)', zIndex: 99998, backdropFilter: 'blur(2px)' }}
                />
                <div style={{ position: 'fixed', inset: 0, zIndex: 99999, display: 'flex', alignItems: 'center', justifyContent: 'center', pointerEvents: 'none' }}>
                    <div style={{ background: '#fff', borderRadius: 16, boxShadow: '0 20px 60px rgba(0,0,0,0.25)', width: '100%', maxWidth: 400, padding: '2rem', pointerEvents: 'auto', textAlign: 'center' }}>
                        <div style={{ width: 64, height: 64, borderRadius: '50%', background: '#fffef0', margin: '0 auto 1.25rem', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <i className="bi bi-box-arrow-right" style={{ fontSize: 28, color: '#c4941a' }}></i>
                        </div>
                        <h5 style={{ fontWeight: 700, color: '#1a1a2e', marginBottom: '0.5rem' }}>Confirm Logout</h5>
                        <p style={{ color: '#6c757d', fontSize: 14, marginBottom: '1.75rem' }}>Are you sure you want to log out of your session?</p>
                        <div className="d-flex gap-3 justify-content-center">
                            <button className="btn btn-light fw-semibold px-4" style={{ borderRadius: 10, minWidth: 110 }} onClick={() => setShowLogout(false)}>Cancel</button>
                            <button className="btn fw-semibold px-4" style={{ borderRadius: 10, minWidth: 110, background: '#c4941a', color: '#fff' }} onClick={handleLogout}>
                                <i className="bi bi-box-arrow-right me-2"></i>Logout
                            </button>
                        </div>
                    </div>
                </div>
            </>,
            document.body
        )}
        </>
    );
};

export default PartnerSidebar;
